const IssuesData = {

    ISSUES: [
                    "Dandruff",
                    "Bad breath",
                    "Bad body odor",
                    "Skin breakouts",
                    "Unkept skin",
                    "Poor teeth",
                    "Yellow teeth",
                    "Dirty hair",
                    "Excess hair on a face",
                    "Dirty hands",
                    "Dirty clothes",
                    "Overweight",
                    "Chronic cell phone use",
                    "Rude",
                    "Tobacco smell",
                    "Offensive feet smell",
                    "Too much perfume",
                    "Excessive make up",
                    "Messy hair",
                    "Hairy legs",
                    "Hairy armpits",
                    "Ear hair",
                    "Nose hair",
                    "Undersdressed",
                    "Overdressed",
                    "Dirty Nails",
                    "Not covering your mouth when coughing or sneezing",
                    "Inappropriate nose blowing or sniffle",
                    "Talking with mouth full",
                    "Burping",
                    "Passing gas",
                    "Talking too loud",
                    "Interrupting",
                    "Chronic cell phone use",
                    "Insulting comments",
                    "Singing with headphones on",
                    "Keeping dirty dishes at your desk",
                    "Talk a lot about your personal issues",
                    "Overusing industry jargon and acronyms",
                    "Stealing others food",
                    "Use 'reply all' without discretion",
                    "Coming to work sick",
                    "Being critical without giving constructive feedback",
                    "Not responding to emails",
                    "Excessive use of profanity",
                    "Checking social media during workday",
                    "Not showing appreciation when being helped",
                    "Inappropriate jokes",
                    "Gossip",
                    "Alcohol smell",
                    "Loud ringtone",
                    "Being late to meetings",
                    "Showing late for work",
                    "Stinky food",
                    "Being negative",
                    "Talking about political or partisan issues",
                    "Commenting on people’s appearance",
                    "Not respecting personal space",
                    "Judging colleagues too harshly",
                    "Being under the influence",
                    "Making derogatory comments about religion"
            ],

    ISSUE_MESSAGES: [
                    "They have noticed that you have dandruff. ",
                     "They have noticed that your breath is not always fresh. ",
                     "They have noticed that you have bad body odor. ",
                     "They have noticed that your skin is breaking out. ",
                     "They have noticed that you have unkempt skin. ",
                     "They have noticed that you have poor teeth. ",
                     "They have noticed that you teeth are yellow. ",
                     "They have noticed that your hair is dirty. ",
                     "They have noticed that you have excess hair on face. ",
                     "They have noticed that your hands are dirty. ",
                     "They have noticed that your clothes are dirty. ",
                     "They have noticed that you are overweight. ",
                     "They have noticed that you use your phone too much. ",
                     "They have noticed that you are rude. ",
                     "They have noticed that you often smell like cigarettes. ",
                     "They have noticed that your feet smell rather badly. ",
                     "They have noticed that you sometimes use too much perfume. ",
                     "They have noticed that you sometimes use too much make up. ",
                     "They have noticed that your hair is sometimes quite messy. ",
                     "They have noticed that your legs would benefit from a shave. ",
                     "They have noticed that your armpits would benefit from a shave. ",
                     "They have noticed that your ears are quite hairy. ",
                     "They have noticed that you have long nose hairs. ",
                     "They have noticed that you sometimes appear underdressed. ",
                     "They have noticed that you sometimes appear overdressed. ",
                     "They have noticed that your nails are often dirty. ",
                     "They have noticed that you don’t always cover your mouth when coughing or sneezing. ",
                     "They have noticed that you often blow your nose or sniffle inappropriately. ",
                     "They have noticed that you often talk with your mouth full. ",
                     "They have noticed that you burp quite frequently and loudly. ",
                     "They have noticed that you often pass gas in front of them. ",
                     "They have noticed that you don’t always control the volume of your voice. ",
                     "They have noticed that you frequently interrupt them when they speak. ",
                     "They have noticed that your use your cell phone is somewhat excessive. ",
                     "They have noticed that some of the comments that you make are rather insulting. ",
                     "They have noticed that you often sing with your headphones on. ",
                     "They have noticed that you keep dirty dishes at your desk. ",
                     "They have noticed that you talk excessively about your personal issues. ",
                     "They have noticed that your use of industry jargon and acronyms is excessive. ",
                     "They have noticed that you seem to take their food. ",
                     "They have noticed that you often unnecessarily keep them in email chains.",
                     "They have noticed that you often come to work while being obviously sick.",
                     "They have noticed that you are often critical without giving constructive feedback. ",
                     "They have noticed that you often don’t respond to their emails. ",
                     "They have noticed that you use profanity rather excessively. ",
                     "They have noticed that you are spending too much time on social media. ",
                     "They have noticed that you often forget to thank them when they help you. ",
                     "They have noticed that some of your jokes are rather inappropriate. ",
                     "They have noticed that you often gossip about your coworkers. ",
                     "They have noticed a smell of alcohol on your breath. ",
                     "They have noticed that your ringtone is rather loud. ",
                     "They have noticed that you are often late to meetings. ",
                     "They have noticed that you frequently come to work late. ",
                     "They have noticed that the food that you bring has a very strong smell. ",
                     "They have noticed that you are often too pessimistic. ",
                     "They have noticed that you often talk about political or partisan issues. ",
                     "They have noticed that your comments on their appearance are inappropriate. ",
                     "They have noticed that you often infringe on their personal space. ",
                     "They have noticed that you frequently judge your colleagues too harshly. ",
                     "They have noticed that you are often appear to be under the influence. ",
                     "They have noticed that you often make derogatory comments about religion.",
                    ],

    AGE_OPTIONS: ["teens", "20s", "30s", "40s", "50s", "60s", "70s", "80s", '90s'],
}

IssuesData.install = function (Vue, options) {
  Vue.prototype.$getConst = (key) => {
    return IssuesData[key]
  }
}

export default IssuesData
